import store from "@frameworks/web/redux/store";
import { AMO_STATUS, AMO_STATUS_ERROR_DATA, AMO_STATUS_HIDE_ERROR_DATA, AMO_STATUS_START_LOADER, AMO_STATUS_STOP_LOADER, } from "../interface/IAMOStatus";
class AMOStatusActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    AMOStatus(amoStatus) {
        this.dispatch({
            type: AMO_STATUS,
            payload: { amoStatus },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: AMO_STATUS_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: AMO_STATUS_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: AMO_STATUS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: AMO_STATUS_STOP_LOADER,
        });
    }
}
export default AMOStatusActions;
